module.exports = __webpack_public_path__ + "static/media/misBeneficios.ab047fc0.svg";